import gql from 'graphql-tag'
import { AggregatePath } from '@/entities/interfaces'
import { ClosingReasonFragment } from '@/graphql/fragments/settings'

const structure: Array<AggregatePath> = [
  { name: 'evaluations', title: 'Evaluation', aggregations: ['count'] },
]
const query = gql`
  ${ClosingReasonFragment}
  query aggregates($model: settings_closing_reason_bool_exp, $aggregate: loans_evaluation_bool_exp, $order: [settings_closing_reason_order_by!]) {
    aggregates: settings_closing_reason(where: $model, order_by: $order) {
      ...ClosingReason
      evaluations: evaluations_aggregate(where: $aggregate) {
        aggregate {
          count(distinct: true)
        }
      }
    }
  }
`
export const aggregate = { structure, query }
export default aggregate
